import { useFocusEffect } from "@react-navigation/native";
import { useSetAtom } from "jotai";
import { useCallback, useEffect, useRef } from "react";

import {
  confirmedBookingModalTypeAtom,
  isConfirmedBookingModalOpenAtom,
} from "../atoms/stores";

export const useResetConfirmedBookingModalOnLeave = (
  bookingKey?: string | null
) => {
  const setConfirmedBookingModalOpen = useSetAtom(
    isConfirmedBookingModalOpenAtom
  );
  const setConfirmedBookingModalType = useSetAtom(
    confirmedBookingModalTypeAtom
  );
  const previousBookingKeyRef = useRef<string | null | undefined>(undefined);

  useFocusEffect(
    useCallback(() => {
      return () => {
        setConfirmedBookingModalType("default");
        setConfirmedBookingModalOpen(false);
      };
    }, [setConfirmedBookingModalOpen, setConfirmedBookingModalType])
  );

  useEffect(() => {
    if (
      previousBookingKeyRef.current !== undefined &&
      previousBookingKeyRef.current !== (bookingKey ?? null)
    ) {
      setConfirmedBookingModalType("default");
      setConfirmedBookingModalOpen(false);
    }
    previousBookingKeyRef.current = bookingKey ?? null;
  }, [bookingKey, setConfirmedBookingModalOpen, setConfirmedBookingModalType]);
};

export const useClearConfirmedBookingModalWhenOpen = (isOpen: boolean) => {
  const setConfirmedBookingModalOpen = useSetAtom(
    isConfirmedBookingModalOpenAtom
  );
  const setConfirmedBookingModalType = useSetAtom(
    confirmedBookingModalTypeAtom
  );

  useEffect(() => {
    if (isOpen) {
      setConfirmedBookingModalType("default");
      setConfirmedBookingModalOpen(false);
    }
  }, [isOpen, setConfirmedBookingModalOpen, setConfirmedBookingModalType]);
};
